import React from "react";
import { useNavigate } from "react-router-dom";
import "./CompletionPage.css";
import { ArrowLeft } from "lucide-react";
import socialPawsLogo from "../../assets/socialPawsLogo.svg";
import MobileTopBar from "../../components/MobileTopBar";
import DesktopTopBar from "../../components/DesktopTopBar";

const CompletionPage = ({ formData, setFormData }) => {
  const navigate = useNavigate();
  const dogName =
    formData.dogName ||
    (formData.dogs?.length > 0
      ? formData.dogs[formData.dogs.length - 1].dogName
      : "{Dog Name}");

  const getDogObject = (data) => ({
    dogName: data.dogName,
    dogGender: data.dogGender,
    dogBirthDate: data.dogBirthDate,
    dogBreed: data.dogBreed,
    dogActivity: data.dogActivity,
    dogAgeGroup: data.dogAgeGroup,
    selectedBreed1: data.selectedBreed1,
    selectedBreed2: data.selectedBreed2,
    selectedBreed3: data.selectedBreed3,
    dogPersonality: data.dogPersonality,
    selectedTraits: data.selectedTraits,
    selectedHobbies: data.selectedHobbies,
    availability: data.availability,
    socialExperienceLevelWithDogs: data.socialExperienceLevelWithDogs,
    socialExperienceWithHumans: data.socialExperienceWithHumans,
    dogPhotos: data.dogPhotos,
    dogBio: data.dogBio,
  });

  const updateDogList = (prev) => {
    if (!prev.dogName) return prev.dogs || [];

    const newDog = getDogObject(prev);
    const existingDogs = prev.dogs || [];

    const isDuplicate =
      existingDogs.length > 0 &&
      existingDogs[existingDogs.length - 1].dogName === newDog.dogName;

    return isDuplicate ? existingDogs : [...existingDogs, newDog];
  };

  const handleAddDog = () => {
    setFormData((prev) => ({
      ...prev,
      dogs: updateDogList(prev),
      dogName: "",
      dogGender: "",
      dogBirthDate: "",
      dogBreed: "",
      dogActivity: "",
      dogAgeGroup: "",
      selectedBreed1: "",
      selectedBreed2: "",
      selectedBreed3: "",
      dogPersonality: [],
      selectedTraits: "",
      selectedHobbies: "",
      availability: "",
      socialExperienceLevelWithDogs: "",
      socialExperienceWithHumans: "",
      dogPhotos: null,
      dogBio: "",
      customPastime: "",
      customPromptAnswer: "",
      customPromptQuestion: "",
      customTrait: "",
      selectedPromptIndex: 0,
      rawAnswers: [],
      isAddingAnotherDog: true,
    }));
    console.log("taps_add_another_dog", formData);
    navigate("/dog-details", { state: { from: "completion" } });
  };

  const handleCreateProfile = () => {
    setFormData((prev) => ({
      ...prev,
      dogs: updateDogList(prev),
    }));
    console.log("taps_creat_your_profile", formData);
    navigate("/user-details-step-one");
  };

  return (
    <div className="completion-container">
      {/* Mobile Top Header (Hidden on Desktop) */}
      {/* <div
        className="dp-mobile-header dp-mobile-only"
        style={{ padding: "2rem 1.5rem 0 1.5rem" }}
      >
        <button
          className="dp-back-btn dp-mobile-back-override"
          onClick={() => navigate("/write-dog-bio")}
        >
          <ArrowLeft size={22} color="#000" strokeWidth={3} />
          <span style={{ color: "#000" }}>Back</span>
        </button>
        <div className="dp-header-logo" style={{ color: "#009fd9" }}>
          <img src={socialPawsLogo} alt="Social Paws" className="dp-logo-img" />
          <span>Social Paws</span>
        </div>
      </div> */}
      <MobileTopBar
        onBack={() => navigate("/write-dog-bio")}
        backColor="#000"
        logoColor="#009fd9"
        blueLogo="true"
        isProtectedRoute={false}
      />

      {/* Desktop Back Button (Pinned to top left) */}
      {/* <button
        className="login-back-btn cp-desktop-only"
        onClick={() => navigate("/write-dog-bio")}
      >
        <ArrowLeft size={24} color="#000" strokeWidth={3} />
        <span style={{ color: "#000" }}>Back</span>
      </button> */}
      <DesktopTopBar
        showBack={true}
        onBack={() => navigate("/write-dog-bio")}
        backColor="#000"
        showProgress={false}
      />

      {/* Main Content */}
      <div className="completion-content">
        <h1 className="completion-title">CONGRATULATIONS!</h1>
        <h1 className="completion-title">
          YOU'VE COMPLETED {dogName.toUpperCase()}'S PROFILE!
        </h1>
        <div className="completion-buttons">
          <button className="completion-button" onClick={handleAddDog}>
            ADD ANOTHER DOG
          </button>
          <button
            className="completion-button button-gap"
            onClick={handleCreateProfile}
          >
            CREATE YOUR PROFILE
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompletionPage;
